interface AccessDeniedProps {
  message?: string
}

export function AccessDenied({ message }: AccessDeniedProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center space-y-4">
        <div className="text-6xl">🔒</div>
        <h1 className="text-xl font-bold text-gray-900">시청할 수 없는 깨처입니다</h1>
        <p className="text-gray-600">{message || '아직 배우지 않은 깨처입니다'}</p>
      </div>
    </div>
  )
}
